import { AutoCoderPipeline } from '../types/gotypes'
import { pipelineSwitchState, showsPipelineSwitches } from './pipelineSwitches'

/**
 * The one word a pipeline row leads with.
 *
 * A long-lived pipeline's `state` is the transient import machinery
 * ('preparing' → 'imported') and stops meaning anything the moment data flows
 * continuously. What an operator actually asks of such a row is "is this
 * thing coding — is it spending money?", so the status IS the coding gate:
 * 'coding on' / 'coding off', derived by the same `pipelineSwitchState` the
 * switch itself reads (an explicit flag wins; otherwise the lifecycle's
 * default). Lifecycle (Active/Paused/Archived) is page state on the pipeline
 * page, not a row status. One-shot pipelines are the opposite: their
 * transient state IS their whole story (created → processing → completed).
 *
 * Failure wins over both — a failed pipeline must never hide behind a gate.
 *
 * Every reader of a pipeline's status — the chip, the status filter, the voice
 * keywords — must go through this, so what you filter by is what you see.
 */
export const pipelineDisplayStatus = (pipeline: AutoCoderPipeline): string => {
  if (pipeline.data_status === 'failed' || pipeline.coding_status === 'failed') return 'failed'
  if (showsPipelineSwitches(pipeline)) {
    return pipelineSwitchState(pipeline).codingEnabled ? 'coding on' : 'coding off'
  }
  return pipeline.state || 'unknown'
}
